
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getAnalytics } from "../api/apiServices";
import { Users, HeartHandshake, BarChart3 } from "lucide-react";

function StatCard({ icon: Icon, label, value, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow"
    >
      <div className="flex items-center gap-3">
        <div className="p-3 rounded-lg bg-orange-100 text-orange-600">
          <Icon className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-gray-500">{label}</p>
          <p className="text-2xl font-bold">
            {value !== null && value !== undefined
              ? new Intl.NumberFormat().format(value)
              : "-"}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

export default function AnalyticsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await getAnalytics();
        setData(res);
      } catch (err) {
        console.error(err);
        setError("Failed to load analytics. Please try again.");
      }
    })();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h2 className="text-2xl text-black font-bold mb-6"> Analytics</h2>

      {error && (
        <p className="text-red-600 mb-4 bg-red-50 p-3 rounded">{error}</p>
      )}

      {!data ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow animate-pulse h-24"
            />
          ))}
        </div>
      ) : (
        <div className="grid bg-gray-200 grid-cols-1 md:grid-cols-3 gap-6">
          <StatCard
            icon={Users}
            label="Users"
            value={data.usersCount}
            delay={0.1}
          />
          <StatCard
            icon={HeartHandshake}
            label="Donations"
            value={data.donationsTotal}
            delay={0.2}
          />
          <StatCard
            icon={BarChart3}
            label="Campaigns"
            value={data.campaignsCount}
            delay={0.3}
          />
        </div>
      )}
    </motion.div>
  );
}
